import { processVariantsTable as processVariantsTableDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

export type VariantsTableProps = {
    sortColumn?: string;
}

export const variantsTable = ({
    sortColumn,
}: VariantsTableProps) => {
    return processVariantsTableDiagram(sortColumn);
};
